import { useNavigate } from 'react-router-dom';
import { Avatar, Box, Card, Typography, useTheme } from '@mui/material';

import { PoolListType, ResGetPoolDetailsCall } from '@/types';
import SymbolSvg from '@/assets/assetfi/Symbol';
import { useWeb3 } from '@/hooks/use-web3';
import { useEffect, useState } from 'react';
import { TOTALFUNDRAISINGMULTIPLIEDPRICE } from '@/lib/common/name-space';
import { addCommas } from '@/lib/util';
import { StateFilter } from '@/lib/filter/stakingPoolState';

const PoolsCard = ({ item, type }: { item: PoolListType; type: string }) => {
  const {
    title,
    // totalStaked,
    // targetAmount,
    interestRate,
    minUsdt,
    state,
    contractAddr,
    goalUsdt,
    totalStakeUsdt,
    poolId,
  } = item;

  // theme
  const theme = useTheme();
  const { web3authCall } = useWeb3();

  // router
  const navigate = useNavigate();


  return (
    <>
      {/* 모바일 */}
      <Card
        onClick={() => {
          console.log(contractAddr);
          navigate('/poolDetail', {
            state: {
              contractAddr: contractAddr,
              poolId,
            },
          });
        }}
        sx={{
          flex: 1,
          cursor: 'pointer',
          display: { xs: 'flex', md: 'none' },
          flexDirection: 'column',
          gap: '24px',
          padding: '24px',
          borderRadius: '20px',
          border: `0.5px solid ${theme.greyscale.lightgrey1}`,
          boxShadow: '0px 0px 4px 0px #00000026',
        }}
      >
        <Box sx={{ display: 'flex', gap: '10px' }}>
          <SymbolSvg width={24} height={24} />
          <Typography variant="h6" color={theme.greyscale.darkgrey2}>
            {title}
          </Typography>
        </Box>

        <Box>
          <Typography variant="body2" color={theme.greyscale.grey1}>
            Total Staked
          </Typography>

          <Typography component={'div'} variant="h6" color={theme.greyscale.darkgrey2}>
            {addCommas(totalStakeUsdt)}{' '}
            <Typography display={'inline'} variant="subtitle2" color={theme.greyscale.darkgrey2}>
              USD
            </Typography>
          </Typography>
        </Box>

        <Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              borderTop: `0.5px solid ${theme.greyscale.lightgrey1}`,
              paddingTop: '8px',
              paddingBottom: '8px',
            }}
          >
            <Typography variant="body2" color={theme.greyscale.grey1}>
              Target Amount (Min)
            </Typography>

            <Box sx={{ textAlign: 'right' }}>
              <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
                {addCommas(goalUsdt)}{' '}
                <Typography display={'inline'} variant="body4" color={theme.greyscale.darkgrey2}>
                  USD
                </Typography>
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              borderTop: `0.5px solid ${theme.greyscale.lightgrey1}`,
              paddingTop: '8px',
              paddingBottom: '8px',
            }}
          >
            <Typography variant="body2" color={theme.greyscale.grey1}>
              APR
            </Typography>

            <Box sx={{ textAlign: 'right' }}>
              <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
                {interestRate} %
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              borderTop: `0.5px solid ${theme.greyscale.lightgrey1}`,
              paddingTop: '8px',
              paddingBottom: '8px',
            }}
          >
            <Typography variant="body2" color={theme.greyscale.grey1}>
              Minimum Deposit
            </Typography>

            <Box sx={{ textAlign: 'right' }}>
              <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
                {addCommas(minUsdt)} USD
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              borderTop: `0.5px solid ${theme.greyscale.lightgrey1}`,
              paddingTop: '8px',
            }}
          >
            <Typography variant="body2" color={theme.greyscale.grey1}>
              Pool Status
            </Typography>

            <Box sx={{ textAlign: 'right' }}>
              <Typography
                variant="subtitle2"
                color={type === 'open' ? theme.background.blue : theme.greyscale.darkgrey2}
              >
                {StateFilter(String(state))}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Card>
      {/* 피시 */}
      <Card
        onClick={() => {
          navigate('/poolDetail', {
            state: {
              contractAddr: contractAddr,
              poolId,
            },
          });
        }}
        sx={{
          flex: 1,
          cursor: 'pointer',
          display: { xs: 'none', md: 'flex' },
          justifyContent: 'space-between',
          padding: '12px 20px',
          borderRadius: '10px',
          border: `0.5px solid ${theme.greyscale.lightgrey1}`,
          boxShadow: '0px 0px 4px 0px #00000026',
          background: type === 'open' ? '#ffffff' : theme.background.default,
        }}
      >
        <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
          <SymbolSvg width={24} height={24} />
          <Box>
            <Typography variant="body3" color={theme.greyscale.grey1}>
              Pool Name
            </Typography>
            <Typography variant="h6" color={theme.greyscale.darkgrey2}>
              {title}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', gap: '20px' }}>
          <Box>
            <Typography variant="body3" color={theme.greyscale.grey1}>
              Total Staked
            </Typography>
            <Typography variant="subtitle1" color={theme.greyscale.darkgrey2}>
              {addCommas(totalStakeUsdt)}{' '}
              <Typography display={'inline'} variant="body3" color={theme.greyscale.darkgrey2}>
                USD
              </Typography>
            </Typography>
          </Box>

          <Box>
            <Typography variant="body3" color={theme.greyscale.grey1}>
              Target Amount (Min)
            </Typography>
            <Typography variant="subtitle1" color={theme.greyscale.darkgrey2}>
              {addCommas(goalUsdt)}{' '}
              <Typography display={'inline'} variant="body3" color={theme.greyscale.darkgrey2}>
                USD
              </Typography>
            </Typography>
          </Box>

          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body3" color={theme.greyscale.grey1}>
              APR
            </Typography>
            <Typography variant="subtitle1" color={theme.greyscale.darkgrey2}>
              {interestRate} %
            </Typography>
          </Box>

          <Box>
            <Typography variant="body3" color={theme.greyscale.grey1}>
              Minimum Deposit
            </Typography>
            <Typography variant="subtitle1" color={theme.greyscale.darkgrey2}>
              {addCommas(minUsdt)}{' '}
              <Typography display={'inline'} variant="body3" color={theme.greyscale.darkgrey2}>
                USD
              </Typography>
            </Typography>
          </Box>
        </Box>

        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body3" color={theme.greyscale.grey1}>
            Pool Status
          </Typography>
          <Typography variant="body1" color={type === 'open' ? theme.background.blue : theme.greyscale.darkgrey2}>
            {StateFilter(String(state))}
          </Typography>
        </Box>
      </Card>
    </>
  );
};

export default PoolsCard;
